import React from 'react';
import { EnumCell } from '@monorepo/ui-kit';
import { enumToSelectOptions } from '@monorepo/helpers';
import { useI18n } from '@monorepo/i18n';
import { ORDER_STATUS } from '../../constants';

type TProps = {
  value: string | number;
  defaultValue: string;
};

const OrderStatusEnum: Component<TProps> = ({ value, defaultValue = '' }) => {
  const { t } = useI18n();
  return (
    <EnumCell
      dictionary={
        enumToSelectOptions(ORDER_STATUS, false, (item) =>
          t(`status.${item}`)
        ) as any
      }
      value={value}
      defaultValue={defaultValue}
    />
  );
};

export default OrderStatusEnum;
